import styled from 'styled-components'

import type { BrandType } from 'services/Branding/types'

export const ItemDivStyled = styled.div<{ $theme: BrandType['theme']; $disabled?: boolean }>`
  display: flex;
  flex-wrap: nowrap;
  color: ${({ $theme }) => $theme.primaryTextColor};
  opacity: ${({ $disabled }) => ($disabled ? 0.3 : 1)};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
`

export const ItemTimeSpanStyled = styled.span`
  width: 50px;
  flex-shrink: 0;
  margin-right: 4px;
`

export const ItemTitleSpanStyled = styled.span`
  width: 230px;
`
